"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var module_1 = require("./module");
exports.FlashMessagesModule = module_1.FlashMessagesModule;
var flash_messages_service_1 = require("./flash-messages.service");
exports.FlashMessagesService = flash_messages_service_1.FlashMessagesService;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-flash-messages/module/index.js
// module id = 252
// module chunks = 4